import { render, staticRenderFns } from "./product-store.vue?vue&type=template&id=5b7abc46&scoped=true&"
import script from "./product-store.vue?vue&type=script&lang=js&"
export * from "./product-store.vue?vue&type=script&lang=js&"
import style0 from "./product-store.vue?vue&type=style&index=0&id=5b7abc46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7abc46",
  null
  
)

export default component.exports